






import { Vue, Component } from 'vue-property-decorator';
import NewList from '@/components/NewsList.vue';
import { projectName } from '../api';
@Component({
  components: {
    NewList,
  },
})
export default class NewsList extends Vue {
  get voteName() {
    return projectName;
  }
}
